import type { MetricType } from './keyResultCard.types';

export const MOCK_KEY_RESULT = {
  id: 'kr-1',
  title: 'Aumentar conversão de demos para vendas',
  metricType: 'percentage' as const,
  unit: '%',
  initialValue: 20,
  targetValue: 35,
  currentValue: 28,
  progress: 53,
  lastCheckInDate: new Date('2025-01-15'),
};

/**
 * Pluraliza uma palavra baseado no valor
 * @param value - Valor numérico
 * @param singular - Forma singular da palavra
 * @param plural - Forma plural da palavra (opcional, adiciona 's' por padrão)
 * @returns Palavra no singular ou plural
 */
function pluralize(value: number, singular: string, plural?: string): string {
  if (value === 1) return singular;
  return plural || `${singular}s`;
}

export function formatMetricValue(
  value: number,
  metricType: MetricType,
  unit: string
): string {
  switch (metricType) {
    case 'percentage':
      // Percentual não precisa de espaço antes do %
      return `${value}${unit}`;
    case 'currency':
      // Moeda: R$ 1.000
      return `${unit} ${value.toLocaleString('pt-BR')}`;
    case 'boolean':
      return value === 1 ? 'Sim' : 'Não';
    case 'number':
    default:
      // Número com unidade: adiciona espaço e pluraliza
      if (!unit) return `${value}`;
      const pluralizedUnit = pluralize(value, unit);
      return `${value} ${pluralizedUnit}`;
  }
}

export function formatDate(date: Date): string {
  return new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(date);
}

export function calculateProgressStatus(
  progress: number
): 'on_track' | 'at_risk' | 'off_track' {
  if (progress >= 70) return 'on_track';
  if (progress >= 40) return 'at_risk';
  return 'off_track';
}
